import React, { useEffect } from 'react';
import { func, node, string } from 'prop-types';
import ReactDOM from 'react-dom';
import classnames from 'classnames/bind';

import styles from './Modal.scss';
const cx = classnames.bind(styles);

function Modal({ className, children, onBackdropClick }) {
  useEffect(() => {
    // lock the background to prevent scroll
    window.document
      .querySelector(':root')
      .style.setProperty('overflow', 'hidden');

    return () => {
      window.document.querySelector(':root').style.overflow = null;
    };
  }, []);

  return ReactDOM.createPortal(
    <div className={cx(styles.wrapper, className)}>
      <div className={styles.backdrop} onClick={onBackdropClick} />
      <div className={styles.content}>{children}</div>
    </div>,
    document.querySelector('#modal')
  );
}

Modal.propTypes = {
  children: node.isRequired,
  className: string,
  onBackdropClick: func,
};

Modal.defaultProps = {
  className: '',
  onBackdropClick: null,
};

export default Modal;



// WEBPACK FOOTER //
// ./app/components/Modal/Modal.jsx